import { cn } from '../../utils/cn';
import type { MobileMenuProps } from '../../types/navigation';

export function MobileMenu({ 
  isOpen, 
  onToggle, 
  sections, 
  activeSection, 
  onSectionClick 
}: MobileMenuProps) {
  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm md:hidden"
          onClick={onToggle}
          aria-hidden="true"
        />
      )}

      {/* Mobile menu panel */}
      <div
        className={cn(
          'fixed top-0 right-0 z-50 h-full w-72 sm:w-80 bg-white shadow-xl transform transition-transform duration-300 ease-in-out md:hidden',
          {
            'translate-x-0': isOpen,
            'translate-x-full': !isOpen
          }
        )}
        role="dialog"
        aria-modal="true"
        aria-label="Mobile navigation menu"
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-border-subtle">
            <h2 className="text-lg font-semibold text-primary-navy">Menu</h2>
            <button
              onClick={onToggle}
              className="p-2 rounded-md text-primary-navy hover:text-accent-gold hover:bg-background-light focus:outline-none focus:ring-2 focus:ring-accent-gold transition-colors duration-200"
              aria-label="Close mobile menu"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Navigation Links */}
          <nav className="flex-1 px-4 py-6">
            <ul className="space-y-2">
              {sections.map((section) => (
                <li key={section.id}>
                  <button
                    onClick={() => onSectionClick(section.id)}
                    className={cn(
                      'w-full text-left px-4 py-3 rounded-lg text-base font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-accent-gold',
                      {
                        'bg-accent-gold/10 text-accent-gold border-l-4 border-accent-gold': 
                          activeSection === section.id,
                        'text-primary-navy hover:bg-background-light hover:text-accent-gold': 
                          activeSection !== section.id
                      }
                    )}
                    aria-current={activeSection === section.id ? 'page' : undefined}
                  >
                    {section.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          {/* Footer */}
          <div className="p-4 border-t border-border-subtle">
            <p className="text-sm text-text-light text-center">
              VC Law Associates
            </p>
          </div>
        </div>
      </div>
    </>
  );
}